(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8167],{

/***/ 44901:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/pdf-tools/encrypt-pdf",
      function () {
        return __webpack_require__(29884);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CalculatorBlogs_Blog; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
;// CONCATENATED MODULE: ./components/CalculatorBlogs/BlogCard.jsx




const BlogCard = (param)=>{
    let { question , answer  } = param;
    const [blogVisible, setBlogVisible] = (0,react.useState)(true);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex mb-[30px] pb-[30px] gap-[20px] border-b border-b-gray-300",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: ()=>blogVisible ? setBlogVisible(false) : setBlogVisible(true),
                className: "pt-[5px] text-[20px] md:text-[35px] w-fit cursor-pointer",
                children: blogVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineMinus */.ywL, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlinePlus */.Lfi, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "question text-[25px] md:text-[30px] mb-[20px] font-medium",
                        children: question
                    }),
                    blogVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "answer text-[16px] md:text-[18px] font-light text-gray-700",
                        children: answer
                    }) : ""
                ]
            })
        ]
    });
};
/* harmony default export */ var CalculatorBlogs_BlogCard = (BlogCard);

;// CONCATENATED MODULE: ./components/CalculatorBlogs/Blog.jsx



const Blog = (param)=>{
    let { heading , BlogData , width ="lg:w-[850px]"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-[100%] mx-auto md:w-[80%] ".concat(width),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-[25px] md:text-[40px] text-center font-bold mb-14 mx-auto",
                children: heading
            }),
            BlogData.map((blog)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CalculatorBlogs_BlogCard, {
                    question: blog.question,
                    answer: blog.answer
                }, blog.id);
            })
        ]
    });
};
/* harmony default export */ var CalculatorBlogs_Blog = (Blog);


/***/ }),

/***/ 3224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants_signature__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24599);





const PdfToolsLinks = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full flex flex-col justify-center items-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "text-center text-2xl md:text-4xl text-gray-800 mb-10",
                children: "Other PDF tools offered by BoloForms"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "max-w-[1280px] mx-auto flex justify-center items-center flex-wrap gap-4",
                children: _constants_signature__WEBPACK_IMPORTED_MODULE_4__/* .signatureTools.map */ .kn.map((tool, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: tool.url,
                        className: "w-[220px] h-[80px] bg-white border rounded-xl drop-shadow-md px-4 hover:shadow-xl transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-105 z-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full h-full grid place-items-center text-xl text-gray-600",
                            children: tool.title
                        })
                    }, index))
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PdfToolsLinks);


/***/ }),

/***/ 86318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8193);
/* harmony import */ var react_icons_bs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63750);
/* harmony import */ var _utils_signature_owner__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10447);






const SignaturePopup = (param)=>{
    let { onPopupClose , source =""  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "bg-gray-600/50 w-full h-full fixed z-[1000] left-0 top-0 p-4 flex justify-center items-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "relative rounded-xl bg-violet-500 w-fit mx-auto lg:w-[700px] md:h-[500px] lg:h-[400px] text-white flex flex-col justify-between gap-[50px] md:gap-[10px] p-[50px] px-[20px] lg:px-[50px]",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    onClick: ()=>onPopupClose(),
                    className: "border border-b-none border-violet-300 shadow-xl absolute top-[20px] right-[20px] hover:opacity-90 cursor-pointer grid place-items-center text-white font-bold text-[20px]",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_4__/* .AiOutlineClose */ .oHP, {
                        className: "font-bold"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col gap-[15px]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-[25px] font-semibold",
                            children: "Take Signatures inside Forms & PDFs!"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-[18px]",
                            children: "Get started for Free"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "",
                            children: [
                                "Integrated Signatures: Add digital signature fields to your forms for easy signing.",
                                "PDF Downloads: Download documents with signatures as PDF files.",
                                "Super easy and simple to use."
                            ].map((item, index)=>{
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex gap-[10px] text-white",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_4__/* .AiFillCheckCircle */ .mny, {
                                                className: "text-[20px]"
                                            })
                                        }),
                                        item
                                    ]
                                }, index);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        target: "_blank",
                        href: "https://signature.boloforms.com/login?from=".concat(source).concat((0,_utils_signature_owner__WEBPACK_IMPORTED_MODULE_3__/* .createUTMQueryParams */ .T0)({
                            from: source
                        })),
                        className: "flex justify-between items-center gap-4 w-fit bg-white text-violet-600 text-[17px] md:text-[20px] px-[20px] py-[8px] md:px-[40px] md:py-[12px] rounded-full hover:opacity-80",
                        children: [
                            "Check out BoloForms ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_5__/* .BsArrowRight */ .lzl, {})
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SignaturePopup);


/***/ }),

/***/ 29884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6154);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _signature_module_css__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(10411);
/* harmony import */ var _signature_module_css__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_signature_module_css__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8193);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89583);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43138);
/* harmony import */ var _components_CalculatorBlogs_Blog__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56130);
/* harmony import */ var _components_SignaturePopup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86318);
/* harmony import */ var _components_PdfToolsLinks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3224);











const BlogData = [
    {
        id: 1,
        question: "What is Encrypt PDF Tool?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "",
                children: "An Encrypt PDF Tool is a tool that allows you to secure your PDF documents by applying encryption methods. Encryption ensures that only authorized users with the correct password or decryption key can access the content of the PDF file."
            })
        })
    },
    {
        id: 2,
        question: "How to Use the Encrypt PDF Tool?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "",
                children: "To use the Encrypt PDF Tool, you need to upload the PDF file you want to encrypt. Then, you can set a password or choose other encryption settings to protect the document. Once encrypted, the PDF file will require the specified password or key for access."
            })
        })
    },
    {
        id: 3,
        question: "Can I Decrypt an Encrypted PDF File?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "",
                children: "Yes, if you have the correct password or decryption key, you can decrypt an encrypted PDF file. Decrypting the file will remove the encryption and allow you to access the content without any restrictions."
            })
        })
    },
    {
        id: 4,
        question: "Is Encrypting PDFs Secure?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "",
                children: "Encrypting PDFs provides a secure way to protect sensitive information. However, it is crucial to use strong, unique passwords and encryption methods to ensure the security of your encrypted PDF documents."
            })
        })
    },
    {
        id: 5,
        question: "What Happens If I Forget the Password for an Encrypted PDF?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "",
                children: "If you forget the password for an encrypted PDF, it can be challenging to regain access to the content. Some PDF encryption tools offer password recovery options, but it is essential to follow best practices and keep a record of your passwords to prevent such situations."
            })
        })
    }
];
function FileUpload() {
    const [file, setFile] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [password, setPassword] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [downloading, setDownloading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [error, setError] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [signaturePopup, setSignaturePopup] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [showPassword, setShowPassword] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    // const scrollToPreview = () => {
    //   const element = document.getElementById("password-field");
    //   if (element) {
    //     element.scrollIntoView({ behavior: "smooth" });
    //   }
    // };
    const handleDrop = (e)=>{
        e.preventDefault();
        if (!e.dataTransfer.files[0]) return;
        const file = e.dataTransfer.files[0];
        setFile(file);
        setError("");
    // scrollToPreview();
    };
    const handleFileChange = async (e)=>{
        if (!e.target.files[0]) return;
        const file = e.target.files[0];
        setFile(file);
        setError("");
    // scrollToPreview();
    };
    const encryptPdf = async ()=>{
        setError("");
        if (!file) {
            setError("Please choose a file");
            return;
        }
        if (file.name.split(".").pop() !== "pdf") {
            setError("Please choose a pdf file");
            return;
        }
        if (!password || password === "") {
            setError("Please enter password");
            return;
        }
        if (file.size > 30000000) {
            setError("File Size is too large(>30MB)");
            return;
        }
        const formData = new FormData();
        formData.append("file", file);
        formData.append("password", password);
        try {
            setDownloading(true);
            const response = await axios__WEBPACK_IMPORTED_MODULE_7__/* ["default"].post */ .Z.post("".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_3__.BASE_URL_POST, "encryptPdf"), formData, {
                responseType: "blob"
            });
            // console.log(response)
            downloadFile(response.data);
        } catch (error) {
            setDownloading(false);
            if (error.response.data.type === "text/html") {
                const blobReader = new FileReader();
                blobReader.addEventListener("loadend", ()=>{
                    setError(blobReader.result);
                });
                blobReader.readAsText(error.response.data);
                return;
            }
            setError(error.response.data);
        }
    };
    const downloadFile = (blob)=>{
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "encrypted.pdf";
        link.click();
        setDownloading(false);
        setSignaturePopup(true);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "w-full mt-20 sm:mt-24",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            charSet: "utf-8"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                            children: "Encrypt PDF Tool - BoloForms"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "description",
                            content: "Encrypt PDF Tool allows you to secure your PDF documents by applying encryption methods. Encryption ensures that only authorized users with the correct password or decryption key can access the content of the PDF file."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "keywords",
                            content: "encrypt pdf, encrypt pdf online, encrypt pdf file, encrypt pdf document, encrypt pdf file online, encrypt pdf file free, encrypt pdf free, encrypt pdf online free, encrypt pdf boloforms, encrypt pdf tool, encrypt pdf tool online, encrypt pdf, secure pdf, secure pdf online, secure pdf file, secure pdf document, secure pdf file online, secure pdf file free, secure pdf free, secure pdf online free, secure pdf boloforms, secure pdf tool, secure pdf tool online, secure pdf, password protect pdf, password protect pdf online, password protect pdf file, password protect pdf document, password protect pdf file online, password protect pdf file free, password protect pdf free, password protect pdf online free, password protect pdf boloforms, password protect pdf tool, password protect pdf tool online, password protect pdf, password protect pdf with password, password protect pdf with password online, password protect pdf with password tool"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "author",
                            content: "BoloForms"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "viewport",
                            content: "width=device-width, initial-scale=1.0"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                            rel: "canonical",
                            href: "https://www.bolosign.com/signature/pdf-tools/encrypt-pdf"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:title",
                            content: "Decrypt PDF Tool - BoloForms"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:description",
                            content: "Encrypt PDF Tool allows you to secure your PDF documents by applying encryption methods. Encryption ensures that only authorized users with the correct password or decryption key can access the content of the PDF file."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:url",
                            content: "https://www.bolosign.com/signature/pdf-tools/encrypt-pdf"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:site_name",
                            content: "BoloForms"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:image:width",
                            content: "1200"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:image:height",
                            content: "630"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:image:alt",
                            content: "BoloForms"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:type",
                            content: "website"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:locale",
                            content: "en_US"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "twitter:card",
                            content: "summary_large_image"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "twitter:site",
                            content: "@BoloForms"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "twitter:creator",
                            content: "@BoloForms"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "twitter:title",
                            content: "Decrypt PDF Tool - BoloForms"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "twitter:description",
                            content: "Encrypt PDF Tool allows you to secure your PDF documents by applying encryption methods. Encryption ensures that only authorized users with the correct password or decryption key can access the content of the PDF file."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                            rel: "canonical",
                            href: "https://www.bolosign.com/signature/pdf-tools/encrypt-pdf"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "max-w-[1280px] mx-auto px-2 md:px-10 py-10 rounded-xl relative flex flex-col gap-20",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "text-violet-500 text-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                            className: "text-3xl md:text-6xl text-gray-800",
                                            children: "Encrypt PDF Tool"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-lg md:text-2xl mt-4 text-gray-600",
                                            children: "Encrypt with a password to prevent others from copying, printing, and editing your PDF document."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "extraOutline p-4 bg-white bg-whtie mx-auto rounded-lg w-full md:w-[600px]",
                                    onDragEnter: (e)=>e.preventDefault(),
                                    onDragOver: (e)=>e.preventDefault(),
                                    onDragLeave: (e)=>e.preventDefault(),
                                    onDrop: handleDrop,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "file_upload px-2 md:px-20 py-5 md:py-14 relative border-4 border-dotted border-gray-300 rounded-lg",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_8__/* .FaFileUpload */ .Gq2, {
                                                className: "text-gray-400 w-20 md:w-32 mx-auto mb-6 md:mb-10 text-[80px] md:text-[120px]"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "input_field flex flex-col w-full mx-auto text-center",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                onChange: handleFileChange,
                                                                className: "text-sm cursor-pointer w-36 hidden",
                                                                type: "file",
                                                                accept: ".pdf"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "text bg-violet-600 text-white text-xl border border-gray-300 rounded-xl font-semibold cursor-pointer py-3 md:py-4 hover:bg-indigo-500",
                                                                children: "Upload PDF File"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "text-gray-600 text-md",
                                                        children: "(Do not upload an already encrypted PDF file. Decrypt it using our Decrypt PDF Tool and then upload it here.)"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        file && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            id: "password-field",
                            className: "password-field",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "w-fit mx-auto flex justify-center mb-1 relative",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                            className: "w-full md:w-[400px] outline-none border-2 border-gray-300 rounded-lg px-4 py-2 text-xl",
                                            type: showPassword ? "text" : "password",
                                            placeholder: "Choose Password",
                                            value: password,
                                            onChange: (e)=>setPassword(e.target.value),
                                            name: "",
                                            id: ""
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "absolute right-2 top-1/2 transform -translate-y-1/2 text-violet-500 text-3xl cursor-pointer",
                                            children: showPassword ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_9__/* .AiFillEyeInvisible */ .p3W, {
                                                onClick: ()=>setShowPassword(false)
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_9__/* .AiFillEye */ .w8I, {
                                                onClick: ()=>setShowPassword(true)
                                            })
                                        })
                                    ]
                                }),
                                error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-red-500 text-center text-xl",
                                    children: error
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-full mt-4",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        onClick: encryptPdf,
                                        className: "bg-violet-600 mx-auto w-[200px] px-2 py-2 text-lg rounded-lg font-semibold text-white flex items-center justify-center gap-4 hover:bg-violet-400",
                                        children: downloading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex items-center text-white space-x-2 ".concat((_signature_module_css__WEBPACK_IMPORTED_MODULE_10___default().loader)),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "",
                                                    children: "Encrypting"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "w-2 h-2 bg-white rounded-full animate-bounce"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "w-2 h-2 bg-white rounded-full animate-bounce"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "w-2 h-2 bg-white rounded-full animate-bounce"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                "Encrypt PDF ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_8__/* .FaKey */ .q2z, {})
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        signaturePopup && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SignaturePopup__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            onPopupClose: ()=>setSignaturePopup(false),
                            source: "ENCRYPT_PDF"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mt-28",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mb-20",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PdfToolsLinks__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CalculatorBlogs_Blog__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    heading: "Encrypt PDF Tool FAQs",
                                    BlogData: BlogData
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (FileUpload);


/***/ }),

/***/ 10411:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"signatureFont":"signature_signatureFont__RxQpu","signatureShadow":"signature_signatureShadow__hfutn","headingAnimation":"signature_headingAnimation___OGQQ","changeImageAnimation":"signature_changeImageAnimation__xeM9_","moveLineAnimation":"signature_moveLineAnimation__uc0qS","changeHeightAnimation":"signature_changeHeightAnimation__AjMNd","rotateIconsAnimation":"signature_rotateIconsAnimation__pFB1R","moveStepsLineAnimation":"signature_moveStepsLineAnimation__MUlje","moveTextUpAnimation":"signature_moveTextUpAnimation__Y6QVi","scrollImageAnimation":"signature_scrollImageAnimation___7bVj","scrollImageAnimationMobile":"signature_scrollImageAnimationMobile__pGKm5","stepsImage":"signature_stepsImage__zJWMg","countryImage":"signature_countryImage__wMRyn","imagePosition":"signature_imagePosition__iJEJi","legalImages":"signature_legalImages__3yVVS","loader":"signature_loader__Zqlyl","topBg":"signature_topBg__j0SDC"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2013,4617,4599,9774,2888,179], function() { return __webpack_exec__(44901); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);